__turbopack_context__.v({
  "art": "community-benefits-module-scss-module__of3nsq__art",
  "benefit": "community-benefits-module-scss-module__of3nsq__benefit",
  "benefit-icon": "community-benefits-module-scss-module__of3nsq__benefit-icon",
  "benefit-list": "community-benefits-module-scss-module__of3nsq__benefit-list",
  "benefits": "community-benefits-module-scss-module__of3nsq__benefits",
  "content": "community-benefits-module-scss-module__of3nsq__content",
  "copy": "community-benefits-module-scss-module__of3nsq__copy",
  "cta": "community-benefits-module-scss-module__of3nsq__cta",
  "heading": "community-benefits-module-scss-module__of3nsq__heading",
  "heading-highlight": "community-benefits-module-scss-module__of3nsq__heading-highlight",
  "price": "community-benefits-module-scss-module__of3nsq__price",
  "price-amount": "community-benefits-module-scss-module__of3nsq__price-amount",
  "single-column": "community-benefits-module-scss-module__of3nsq__single-column",
  "text-block": "community-benefits-module-scss-module__of3nsq__text-block",
});
